(function () {
    angular.module('Services')
        .factory('Carrier', function (Request, $q, $rootScope) {
            const getDeferred = (url, cache) => {
                return (success, error) => {
                    let defer = $q.defer();

                    Request.get({
                        url,
                        cache,
                        successCallback: defer.resolve,
                        errorCallback: defer.reject
                    });

                    defer.promise.then(success).catch(error);

                    return defer.promise;
                };
            };
            return {
                getCarriers: function (successCallback, errorCallback) {
                    var serviceCallback = false;
                    Request.get({
                        url: ApiURLs.carrier.carriers,
                        method: 'GET',
                        successCallback: function (data) {
                            successCallback(data);
                            if (serviceCallback) {
                                serviceCallback(buildServices(data));
                            }
                        },
                        errorCallback: errorCallback
                    });
                    function buildServices(carriers) {
                        var services = [];
                        angular.forEach(carriers, function (carrier) {
                            angular.forEach(carrier.services, function (service) {
                                service.carrierId = carrier.id;
                                service.rateCategories = [
                                    {
                                        "name": "Weight Based",
                                        "value": "byweight",
                                        "categories": [
                                            "basic",
                                            "minimum",
                                            "perKgRate"
                                        ]
                                    },
                                    {
                                        "name": "Item/container based",
                                        "value": "bypallet",
                                        "categories": [
                                            "itemValue",
                                            "cubicConversion",
                                            "minQuantity",
                                            "maxQuantity"
                                        ]
                                    }
                                ];
                                services.push(service);
                            })
                        });
                        return services;
                    };
                    function getServices(callback) {
                        serviceCallback = callback;
                    };
                    return {
                        getServices: getServices
                    }
                },
                getServiceProfiles: function (successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfiles,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getServiceProfile: function (id, successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfiles + id,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                getCarrierProfiles: function (id, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.carrierProfiles.replace(':id', id),
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getServiceProfileSetup: function (successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.getServiceProfileSetup,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                getAllServiceThresholds: function (options, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfiles + options.serviceProfileId + '/thresholds/' + options.path,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getQuote: function (payload, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.getQuote,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                createServiceThreshold: function (options, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + options.serviceProfileId + '/thresholds/' + options.path,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                getServiceThreshold: function (options, successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfiles + options.serviceProfileId + '/thresholds/' + options.path + '/' + options.thresholdId,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                updateServiceThreshold: function (options, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + options.serviceProfileId + '/thresholds/' + options.path + '/' + options.thresholdId,
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                deleteServiceThreshold: function (options, successCallback, errorCallback) {
                    Request.delete({
                        url: ApiURLs.carrier.serviceProfiles + options.serviceProfileId + '/thresholds/' + options.path + '/' + options.thresholdId,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                getServiceRateCards: function (id, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates',
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters,
                        disableAbort: true
                    });
                },
                importWeightRateCards: function (id, successCallback, errorCallback, file, filters) {
                    Request.upload({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates/import',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    }, file);
                },
                importItemRateCards: function (id, successCallback, errorCallback, file, filters) {
                    Request.upload({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates/item-charges/import',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    }, file);
                },
                importTimeRateCards: function (id, successCallback, errorCallback, file, filters) {
                    Request.upload({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates/time-based/import',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    }, file);
                },
                importVolumeRateCards: function (id, successCallback, errorCallback, file, filters) {
                    Request.upload({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates/volume-based/import',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    }, file);
                },
                confirmRateCards: function (id, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates/approve',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                rejectRateCards: function (id, successCallback, errorCallback) {
                    Request.delete({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates/reject',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                createServiceRateCard: function (id, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rates',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                updateServiceRateCard: function (ids, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + ids.serviceProfileId + '/rates/' + ids.rateId,
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                deleteServiceRateCard: function (ids, successCallback, errorCallback) {
                    Request.delete({
                        url: ApiURLs.carrier.serviceProfiles + ids.serviceProfileId + '/rates/' + ids.rateId,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                deleteSelectedRateCard: function (payload, successCallback, errorCallback) {
                    const url = ApiURLs.carrier.serviceProfiles + payload.serviceProfileId + '/rates?rateIds=' + payload.rateIds.toString()
                    Request.post({
                        url: url,
                        method: 'DELETE',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                calculateDuration: function (successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.externalCarrierProfile + 'calculate-duration',
                        method: 'POST',
                        successCallback,
                        errorCallback
                    }, data);
                },
                enableReciprocal: function (ids, successCallback, errorCallback, serviceProfileId) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + serviceProfileId + '/rates/reciprocals/enable',
                        method: 'POST',
                        successCallback,
                        errorCallback
                    }, ids);
                },
                disableReciprocal: function (ids, successCallback, errorCallback, serviceProfileId) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + serviceProfileId + '/rates/reciprocals/disable',
                        method: 'POST',
                        successCallback,
                        errorCallback
                    }, ids);
                },
                getRatePreview: function (id, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rate-previews',
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                sendRatePreview: function (id, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + id + '/rate-previews',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, data);
                },
                getExternalCarrierProfile: function (profileId, successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.externalCarrierProfile + profileId,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    });
                },
                getExternalCarrierProfiles: function (successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.externalCarrierProfiles,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getSharedCarrierProfiles: function (successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.externalCarrierProfiles,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getFuelLevies: function (successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.fuelLevy,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                createFuelLevy: function (successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.fuelLevy,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                updateFuelLevy: function (id, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.fuelLevy + id,
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                getLoadRatesCTT: getDeferred(ApiURLs.carrier.loadRatesCTT, true),
                getZonePostcodeFiles: function (carrierId, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.getZonePostcodeFiles + carrierId + '/zones',
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getZonePostcodeFileDetail: function (carrierId, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.getZonePostcodeFiles + carrierId + '/zones',
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },
                getZonePostcodes: function (ids, successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.getZonePostcodeFiles + ids.carrierProfileId + '/zones/' + ids.zoneId + '/postcodes',
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },

                getZonePostcodesWorldwide: function (successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.getZonePostcodesWorldwide,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                addZoneProfile: function (carrierProfileId, payload, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.getZonePostcodeFiles + carrierProfileId + '/zones',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },
                addZonePostcode: function (ids, payload, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.getZonePostcodeFiles + ids.carrierProfileId + '/zones/' + ids.zoneId + '/postcodes',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },
                importZonePostcode: function (id, successCallback, errorCallback, file, eventCallback) {
                    Request.upload({
                        url: ApiURLs.carrier.getZonePostcodeFiles + id + '/zones/import',
                        method: 'POST',
                        successCallback,
                        errorCallback,
                        eventCallback
                    }, file);
                },
                confirmImportZonePostcode: function (id, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.getZonePostcodeFiles + id + '/zones/approve',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                rejectImportZonePostcode: function (id, successCallback, errorCallback) {
                    Request.delete({
                        url: ApiURLs.carrier.getZonePostcodeFiles + id + '/zones/reject',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                removeZoneProfile: function (ids, successCallback, errorCallback) {
                    Request.delete({
                        url: ApiURLs.carrier.getZonePostcodeFiles + ids.carrierProfileId + '/zones/' + ids.zoneId,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                removeZonePostcode: function (ids, payloadIds, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.getZonePostcodeFiles + ids.carrierProfileId + '/zones/' + ids.zoneId + '/postcodes/delete',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payloadIds);
                },
                removeSelectedZonePostcode: function (id, successCallback, errorCallback, zoneIds) {
                    Request.delete({
                        url: ApiURLs.carrier.getZonePostcodeFiles + id + '/zones' + zoneIds,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                getAllCustom: getDeferred(ApiURLs.carrier.getAllCustom, true),
                // getAllAvailable: getDeferred(ApiURLs.carrier.getAllAvailable, true),
                getTrackingInformation: getDeferred(ApiURLs.carrier.getTrackingInformation, true),
                getTrackingPublic: getDeferred(ApiURLs.carrier.getTrackingPublic, true),
                //Commented by K, don't know why not working
                //getServiceDetail: getDeferred(ApiURLs.carrier.getServiceDetail, true),
                getServiceDetail: function (serviceId, successCallback, errorCallback) {
                    Request.get({
                        //url: ApiURLs.carrier.getServiceDetail + '/' + serviceId,
                        url: ApiURLs.carrier.getServiceDetail,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                getAllAvailable: function (successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.getAllAvailable,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                updateServiceProfileNames: function(id, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.updateNames.replace(':id', id),
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                updateServiceProfile: function (id, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + id,
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                createServiceProfile: function (successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                cloneServiceProfile: function (successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + 'cloneserviceprofile',
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                postCustom: function (data, onSuccess, onError) {
                    Request.post({
                        url: ApiURLs.carrier.postCustom,
                        method: 'POST',
                        successCallback: onSuccess,
                        errorCallback: onError
                    }, data);
                },
                postLabel: function (data, onSuccess, onError) {
                    Request.post({
                        url: ApiURLs.carrier.postLabel,
                        method: 'POST',
                        successCallback: onSuccess,
                        errorCallback: onError
                    }, data);
                },
                createExternalCarrierProfile: function (data, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.externalCarrierProfile,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                updateExternalCarrierProfile: function (id, data, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.externalCarrierProfile + data.carrierId + '/' + id,
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                activateCarrierProfilesToNetwork: function (ids, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.externalCarrierProfile + 'network/activate',
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, ids);
                },
                deactivateCarrierProfilesToNetwork: function (ids, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.externalCarrierProfile + 'network/deactivate',
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, ids);
                },
                activateServiceProfilesToNetwork: function (ids, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + 'network/activate',
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, ids);
                },
                deactivateServiceProfilesToNetwork: function (ids, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.serviceProfiles + 'network/deactivate',
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, ids);
                },
                getCarrierAccountNumbers: function (id, successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.accountNumbers.replace(':carrierId', id),
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback, errorCallback
                    });
                },
                uploadServiceProfileLogo: function (file, id, successCallback, errorCallback) {
                    Request.upload({
                        url: ApiURLs.carrier.uploadServiceProfileLogo.replace(':id', id),
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        headers: {
                            'Accept': 'plain/text'
                        }
                    }, file);
                },
                uploadCarrierProfileLogo: function (file, id, successCallback, errorCallback) {
                    Request.upload({
                        url: ApiURLs.carrier.uploadCarrierProfileLogo.replace(':id', id),
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, file);
                },
                uploadCarrierPostCode: function (zoneDetails, callback, errCallback, file, eventCallback) {
                    console.log(zoneDetails)
                    Request.upload({
                        url: ApiURLs.carrier.importCSVPostCode.replace(':id', zoneDetails.id).replace(':zoneId', zoneDetails.zoneId).replace(':countryName', zoneDetails.countryName),
                        method: 'POST',
                        successCallback: callback,
                        errorCallback: errCallback,
                        eventCallback
                    }, file)
                },
                createCrateArtworkConfig: function (payload, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.crate,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },

                getCratePlywoodConfig: function(successCallback, errorCallback) {
                    Request.post({
                        url: `${ApiURLs.carrier.crate}/plywood`, 
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },

                createCratePlywoodConfig: function(payload, successCallback, errorCallback) {
                    Request.post({
                        url: `${ApiURLs.carrier.crate}/plywood`, 
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },

                updateCratePlywoodConfig: function(payload, successCallback, errorCallback) {
                    Request.post({
                        url: `${ApiURLs.carrier.crate}/plywood`, 
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },
                updateCrateConfig: function (payload, successCallback, errorCallback) {
                    Request.post({
                        url: ApiURLs.carrier.crate+'/artwork',
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, payload);
                },
                getCrateConfig: function (successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.carrier.crate+'/artwork',
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },

                carrierProfilesCompact: function(successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.carrierProfileCompact,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                },

                serviceProfilesCompact: function(successCallback, errorCallback, filters) {
                    Request.get({
                        url: ApiURLs.carrier.serviceProfileCompact,
                        method: 'GET',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: filters
                    });
                }
            };
        });
})();



// WEBPACK FOOTER //
// ./js/services/carrier.js